import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmMessageComponent } from './presentationals/messages/confirm-message/confirm-message.component';
import { ErrorMessageComponent } from './presentationals/messages/error-message/error-message.component';
import { SuccessMessageComponent } from './presentationals/messages/success-message/success-message.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LoaderComponent } from './presentationals/loader/loader.component';
import { SiteTemplateComponent } from './containers/site-template/site-template.component';
import { RouterModule } from '@angular/router';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { LanguageSelectorComponent } from './presentationals/language-selector/language-selector.component';
import { MatDialogModule } from '@angular/material/dialog';
import { RoundPipe } from '../core/pipes/round.pipe';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDateFormats, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { SafeHtmlPipe } from '../core/pipes/safe-html.pipe';
import { ReplacePipe } from '../core/pipes/replace.pipe';
import { PaymentMethodsComponent } from './presentationals/payment-methods/payment-methods.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileUploadComponent } from './presentationals/file-upload/file-upload.component';
import { CustomTelInputComponent } from './presentationals/custom-tel-input/custom-tel-input.component';
import { TextDialogComponent } from './presentationals/text-dialog/text-dialog.component';
import { provideEnvironmentNgxCurrency, NgxCurrencyInputMode, NgxCurrency } from '@dintecom/ngx-currency';
import IntlTelInput from "@intl-tel-input/angular";
import { FormErrorComponent } from './presentationals/form-error/form-error.component';

export const customDateFormat: MatDateFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY'
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

const sharedModules = [
  CommonModule,
  RouterModule,
  TranslateModule,
  ReactiveFormsModule,
  MatSnackBarModule,
  MatButtonModule,
  MatCheckboxModule,
  MatCardModule,
  MatExpansionModule,
  MatInputModule,
  MatIconModule,
  MatTooltipModule,
  MatListModule,
  MatMenuModule,
  MatToolbarModule,
  MatSidenavModule,
  MatSelectModule,
  MatDatepickerModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatTabsModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatMomentDateModule,
  MatAutocompleteModule,
  MatChipsModule,
  MatRadioModule,
  MatGridListModule
]

const sharedComponents = [
  LoaderComponent,
  SiteTemplateComponent,
  LanguageSelectorComponent,
  PaymentMethodsComponent,
  FileUploadComponent,
  CustomTelInputComponent,
  FormErrorComponent
];

const customPipes = [
  RoundPipe,
  SafeHtmlPipe,
  ReplacePipe
];

@NgModule({
  declarations: [
    sharedComponents,
    customPipes,
    ConfirmMessageComponent,
    ErrorMessageComponent,
    SuccessMessageComponent,
    CustomTelInputComponent,
    TextDialogComponent,
  ],
  imports: [
    sharedModules,
    NgxCurrency,
    IntlTelInput
  ],
  exports: [
    sharedModules,
    sharedComponents,
    customPipes,
    NgxCurrency,
    IntlTelInput
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: customDateFormat },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    provideEnvironmentNgxCurrency({
      align: "left",
      allowNegative: true,
      allowZero: true,
      decimal: ".",
      precision: 0,
      prefix: "",
      suffix: "",
      thousands: "'",
      nullable: true,
      min: null,
      max: null,
      inputMode: NgxCurrencyInputMode.Financial,
    })
  ]
})
export class SharedModule {
}
